// extracted by mini-css-extract-plugin
module.exports = {"parkinglotttag":"style_parkinglotttag__lreN8"};